import { Component, ViewEncapsulation, Input, OnDestroy, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NotifierService } from '../../../shared/notifier/notifier.service';
import { Subscription } from 'rxjs/Subscription';
import { BudgetService } from '../../../services/budget.service';
import { IBudgetDetail } from '../new-budget.component';
import { ActivatedRoute, Routes, Router } from '@angular/router';
import { ProviderService } from '../../../services/provider.service';
import { InternalService } from '../../../services/internal.service';
@Component({
    selector: 'app-oc-budget',
    templateUrl: 'ocBudgetModal.component.html',
    styleUrls: ['./ocBudgetModal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [BudgetService, ProviderService]
})
export class OcBudgetModalComponent implements OnDestroy {
    budgetId: number;
    budgetDetails: any = [];
    modalTitle = '';
    buttonText = '';
    subscription: Subscription;
    providers: any;
    constructor(public dialogRef: MatDialogRef<OcBudgetModalComponent>,
        private notifierService: NotifierService,
        private providerService: ProviderService,
        private internalService: InternalService,
        private routes: Router,
        private zone: NgZone) {

        this.providerService.listProviders().subscribe((result) => {
            this.providers = result;
            this.handleNotify();
        });
    }

    handleNotify() {
        this.subscription = this.notifierService.behaviorNotifierObject$.subscribe(
            message => {
                this.zone.run(() => {
                    this.budgetDetails = message.object.data;
                    this.budgetId = this.budgetDetails[0].id_budget_header;
                    this.buttonText = 'Generar OC';
                    this.modalTitle = 'Selección Detalles de OC';
                    console.log("asda", this.budgetDetails);
                });

            }
        );
    }

    close() {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    generateOC() {
        let itsOk = true;
        let detailsSelected = this.budgetDetails.filter(line => line.selected);
        if (detailsSelected.length > 0) {
            let firstProvider = detailsSelected[0].provider_id;
            detailsSelected.forEach(element => {
                if (element.provider_id != firstProvider) {
                    itsOk = false;
                }
            });
            if (itsOk) {
                this.internalService.internalNotify({ from: 'ocBudgetModal', dataList: detailsSelected });
                this.close();
                this.routes.navigate(['system/buy-order/new/' + this.budgetId]);
            } else {
                this.notifierService.systemNotify({
                    title: 'Ha ocurrido un error',
                    message: 'Solo puede crear una OC si los detalles tienen el mismo proveedor.',
                    type: 'error'
                });
            }
        } else {
            console.log("adkasldkanlskn");
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor seleccione items para su Orden de Compra.',
                type: 'error'
            });
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/system/budget/new-budget/ocBudgetModal/ocBudgetModal.component.ts